var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFloppyDisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 0H5.914C5.38316 -0.0012207 4.87395 0.210205 4.5 0.587036L0.585999 4.5C0.211487 4.87573 0.000839233 5.38452 0 5.91504V22C0 23.1046 0.895432 24 2 24H22C23.1046 24 24 23.1046 24 22V2C24 0.895386 23.1046 0 22 0ZM18.5 2C18.7761 2 19 2.22388 19 2.5V6.5C19 7.32837 18.3284 8 17.5 8H7.5C6.67157 8 6 7.32837 6 6.5V2.5C6 2.22388 6.22386 2 6.5 2H18.5ZM4.5 21.5C4.5 21.7761 4.72386 22 5 22H20C20.2761 22 20.5 21.7761 20.5 21.5V13.5C20.5 12.6716 19.8284 12 19 12H6C5.17157 12 4.5 12.6716 4.5 13.5V21.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.25098V5.75098C15 6.16519 15.3358 6.50098 15.75 6.50098C16.1642 6.50098 16.5 6.16519 16.5 5.75098V4.25098C16.5 3.83676 16.1642 3.50098 15.75 3.50098C15.3358 3.50098 15 3.83676 15 4.25098Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16.251H13.5C13.9142 16.251 14.25 15.9152 14.25 15.501C14.25 15.0868 13.9142 14.751 13.5 14.751H7C6.58579 14.751 6.25 15.0868 6.25 15.501C6.25 15.9152 6.58579 16.251 7 16.251Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20.251H18C18.4142 20.251 18.75 19.9152 18.75 19.501C18.75 19.0868 18.4142 18.751 18 18.751H7C6.58579 18.751 6.25 19.0868 6.25 19.501C6.25 19.9152 6.58579 20.251 7 20.251Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloppyDisk);
export default __webpack_public_path__ + "static/media/floppyDisk.d523658f.svg";
export { ForwardRef as ReactComponent };